export default {
  lawsAndRegulations: {
    seleteTitle: '你選擇的是：',
    title1: '最高人民法院關於為海南全面深化改革開放提供司法服務和保障的意見',
    title2: '國務院關於同意設立中國（海南）自由貿易試驗區的批復',
    title3: '海南省旅遊條例',
    desc1:
      '法發〔2018〕16號為深入學習貫徹習近平新時代中國特色社會主義思想和黨的十九大精神，認真貫徹落實以習近平衕誌為覈心的黨中央關於支持海南全面深化改革開放的重大決策部署，充分發揮人民法院職能作用，推動海南自由貿易試驗區和中國特色自由貿易港建設，根據《中共中央國務院關於支持海南全面深化改革開放的指導意見》和《最高人民法院關於為自由貿易試驗區建設提供司法保障的意見》，製定如下意見。',
    desc2:
      '國務院關於同意設立中國（海南）自由貿易試驗區的批復（國函〔2018〕119號）海南省人民政府、商務部：你們關於設立中國（海南）自由貿易試驗區的請示收悉。現批復如下：',
    desc3:
      '為保障旅遊者、旅遊經營者及其從業人員的合法權益，保護和合理利用旅遊資源，規範旅遊市場秩序，推進海南國際旅遊島建設，促進旅遊業持續健康發展，根據《中華人民共和國旅遊法》及有關法律、法規，結合本省實際，製定本條例。'
  },
  classType: {
    multilevel: '多級包含',
    singlelevel: '單級統計'
  },
  accountjd: {
    emailMsg: '可填寫郵箱，作為登錄賬號',
    phoneOremail: '手機號為登錄賬號！',
    phoneOremail2: '郵箱為登錄賬號！',
    phoneMsg: '手機號或郵箱，必填一項',
    otherphoneMsg: '境外手機號不支持登錄'
  },
  centerThree: {
    number: '編號：',
    countdown: '倒計時：',
    isoverdue: '已逾期：',
    mediationProgress: '調解進度',
    disputeOccurred: '糾紛發生地',
    applicant: '申請人',
    respondent: '被申請人',
    applicantsAgent: '申請人代理人',
    respondentsAgent: '被申請人代理人',
    disputeDescription: '糾紛描述',
    applicantsAppeal: '申請人訴求',
    registrationTime: '登記時間：',
    detailsDispute: '糾紛詳情',
    judicial: '司法確認',
    arbitration: '在線仲裁',
    litigation: '訴訟立案',
    crossExamination: '質  證',
    applicationExtension: '申請延期',
    confirmExtension: '確認延期',
    applicationFiling: '申請立案',
    haveAppliedJudicialConfirmation: '已申請司法確認',
    ApplyJudicialConfirmation: '申請司法確認',
    haveAppliedApplicationMediation: '已申請調解申請書',
    applyApplicationMediation: '申請調解申請書',
    extensionConfirmation: '延期確認',
    numberDaysExtended: '延期天數：',
    reasonsExtension: '延期理由：',
    numberDaysExtended2: '延期天數',
    reasonsExtension2: '延期理由',
    reject: '拒 絕',
    confirm: '確 認',
    extensionCertification: '延期認證',
    reasonsApplication: '申請理由',
    pleaseEnter: '請輸入內容',
    waitingMediation: '等待調解',
    inMediation: '調解中',
    mediationSucceed: '調解成功',
    mediationFail: '調解失敗',
    decideWhetherWithdraw:
      '請您根據實際情況決定是否撤回，一旦撤回，調解機構將不爲您提供調解服務。',
    warmPrompt: '溫馨提示',
    whetherToAsk:
      '是否請求法院出具調解書，若點擊"確認"，將爲您跳轉至請求頁面。',
    tips: '提示',
    tips1: '溫馨提示',
    extensionNumber: '延期必須爲數字',
    enterExtension: '請輸入延期理由',
    cantBeBlank: '延期理由不可爲空',
    validationDidntPass: '表單驗證未通過',
    confirmExtensionSucceed: '成功確認延期',
    haveRefusedExtension: '已拒絕延期',
    applicationForLitigation: '申請訴訟',
    haveAppliedForLitigation: '已申請訴訟',
    cancel: '取 消',
    orJudicial: '是否提交司法確認申請？',
    orLitigation: '是否申請訴訟立案？',
    orArbitration: '是否在線轉仲裁？',
    submitApplySucceed: '提交申請成功',
    judicialed: '已申請司法確認',
    litigationed: '已申請訴訟立案',
    arbitrationed: '已申請在線仲裁',
    ApplySuitConfirmation: '訴訟',
    ApplyConfirmation: '在線仲裁',
    mediatorRecordingReminder:
      '調解員{mediatorName}已開始錄製視頻，請注意言辭參與調解'
  },
  step3: {
    respondentsInformation: '被申請人{number}信息：',
    respondentType: '被申請人類型：',
    respondentsName: '被申請人姓名：',
    respondentGender: '被申請人性別：',
    respondent: '被申請人：',
    enterOneContact: '請至少輸入被申請人{number}的一個聯系方式，手機',
    enterRespondentsTel: '請輸入被申請人{number}的手機號！'
  },
  step2: {
    cancel: '取消',
    legalRepresentative: '法定代表人：',
    contactNumber: '聯系電話：',
    haveAdded: '已添加',
    added: '已新增',
    applicant: '申請人：',
    haveDeleted: '已刪除',
    haveUpdate: '已修改',
    applicantsInformation: '申請人{number}信息：',
    examinationAndApproval: '法官審批中',
    applicantType: '申請人類型：',
    applicantName: '申請人姓名：',
    enterRealName: '請填寫真實姓名',
    gender: '性別：',
    enterPhoneNumber: '請輸入手機號',
    enterOneWay: '請至少輸入一個聯系方式，手機／電子郵箱',
    enterPhoneRequired: '請輸入手機號（手機或郵箱必填一項）',
    enterEmailRequired: '請輸入郵箱號（手機或郵箱必填一項）',
    IDNumber: '身份證號：',
    IDNumber2: '身份證號',
    enterIDNumber: '請填寫十八位二代身份證號',
    detailAddress: '詳細地址：',
    detailAddressIsRequired: '詳細地址爲必填項',
    useIssuingInstrument: '出具文書時使用',
    enterOrganiztionsName: '請輸入單位名稱',
    creditCode: '信用代碼：',
    enterUnifiedSocialCreditCode: '請輸入統一社會信用代碼',
    enterName: '請輸入姓名',
    legalPersonGender: '法人性別：',
    enterDetailedAddress: '請輸入詳情地址',
    organizationsRepresentative: '機構代表人：',
    representativeGender: '代表人性別：',
    agent: '代理人：',
    agent2: '代理人',
    Optional: '(選填)有代理人請填寫代理人信息，無代理人的無需填寫',
    delegateType: '委托類型：',
    agentType: '代理人類型：',
    agentName: '代理人姓名：',
    agentGender: '代理人性別',
    enterUsefulTel: '請填寫常用電話',
    letterAuthorization: '授權委托書：',
    uploadLetterAuthorization: '請上傳授權委托書',
    telFormatIncorrect: '手機號格式不正確',
    IDCardFormatIncorrect: '身份證格式不正確',
    creditCodeFormatIncorrect: '信用代碼格式錯誤',
    naturalPerson: '自然人',
    unincorporatedOrganization: '非法人組織',
    generalAuthorizedAgent: '一般授權代理人',
    specialAuthorizedAgent: '特別授權代理人',
    cantBeModified: '當前人員已有信息處于審批中，暫不可修改',
    expand: '展開',
    hide: '收起',
    operateAgain: '表單信息輸入不正確，請重新操作',
    enterOneContact: '請至少輸入申請人{number}的一個聯系方式，手機',
    enterApplicantsTel: '請輸入申請人{number}的手機號！',
    reuploadFile: '請重新上傳文件',
    hasntLoggedIn: '用戶未登錄',
    deleteFile: '此操作將永久刪除該文件, 是否繼續',
    deletionCanceled: '已取消刪除',
    nationality: '國籍：',
    selectNationality: '請選擇國籍',
    national: '民族：',
    national2: '民族',
    deleteAgent: '刪除代理人'
  },
  step1: {
    areasOfExpertise: '擅長領域:',
    organization: '機 構：',
    organizationType2: '機構類別',
    enter: '請填寫',
    detailAddress: '詳細地址：',
    disputeType: '糾紛類型：',
    disputeOccurred: '糾紛發生地：',
    disputeDescription2: '糾紛描述：',
    disputeDescription:
      '糾紛描述是指您申請調解的事項的基本情況，如發生糾紛的事情經過。',
    myAppeal: '我的訴求：',
    myappealPurpose: '我的訴求是指您申請調解想要達到的目的',
    mediationOrganization: '調解機構：',
    selectMediationOrganization: '選擇調解機構',
    organizationType: '機構類型：',
    searchMediationOrganization: '搜索調解機構',
    number: '序號',
    residentArea: '常住地區：',
    fieldExpertise: '擅長領域',
    organizationLocation: '機構所在地',
    numberMediators: '調解員人數',
    pleaseSelect: '請選擇',
    searchMediator: '搜索調解員',
    nextStep: '下一步',
    selectType: '請選擇一個類型',
    clickStartVoice: '點擊開始語音',
    province: '廣東省廣州市',
    selectMediationOrganizationFirst: '請先選擇調解機構',
    voiceNotSupported: '當前浏覽器不支持語音轉文字',
    updateSecceed: '更新成功'
  },
  evidence: {
    uploadEvidence: '上傳證據',
    identityCertificate: '身份證明',
    materialName: '材料名稱：',
    uploadMaterial: '材料上傳',
    uploader: '上傳者：',
    noInformationAvailable: '暫無資料',
    listEvidence: '證據清單',
    authenticity: '真實性',
    enterReason: '請輸入理由',
    accepted: '認可',
    notAccepted: '不認可',
    legality: '合法性',
    relevance: '關聯性',
    crossExamination: '質證',
    opinionsCrossExamination: '質證意見',
    haveCrossExamination: '已質證',
    crossExaminationSucceed: '質證成功',
    crossexaminationCantBeBlank: '質證意見不能爲空',
    chooseRecognition: '請選擇對證據的認可與否的態度',
    continueDeletingfile: '是否繼續刪除該文件？',
    deletionSucceed: '刪除成功！',
    other: '其他'
  },
  clerK: {
    uploadDocuments: '上傳文書'
  },
  mediationRecord: {
    mobilePhoneNumber: '手機號：',
    mobilePhoneNumber2: '手機號',
    record: '筆錄：',
    location: '地點：',
    time: '時間：',
    participant: '參會者：',
    happy: '高興',
    angry: '憤怒',
    sad: '悲傷',
    calm: '平靜',
    notStart: '未開始',
    underWay: '進行中',
    videoMediation: '視頻調解',
    videoInvestigation: '視頻調查',
    videoAuthentication: '視頻認證',
    offlineMediation: '線下調解',
    offlineInvestigation: '線下調查',
    invitationObservation: '邀請觀摩',
    enterVideo: '進入視頻',
    videoRecording: '視頻記錄',
    sendTranscript: '發送筆錄',
    viewTranscript: '查看筆錄',
    faceRecognitionExpression: '人臉識別表情占比',
    videoDuration: '視頻時長(分鍾)',
    clickPlay: '點擊播放 或 右擊鏈接另存爲',
    noRecordsYet: '暫無記錄',
    enterTime: '請輸入時間',
    enterDisputeType: '請輸入糾紛類型',
    enterAddress: '請輸入地址',
    enterDetailAddress: '請輸入詳細地址',
    enterDetailAddressAndNation: '請輸入國家地區及詳細地址',
    enterIdNumber: '請輸入身份證號',
    haveSent: '已發送',
    refresh: '刷新',
    agree: '同意',
    reject: '拒絕',
    send: '發送',
    save: '保存',
    scanQR: '掃描二維碼',
    signatureCompleted: '已經完成手寫簽名',
    afraid: '恐懼',
    annoyed: '厭惡',
    surprised: '驚奇',
    savedSuccessfully: '情緒識別保存成功',
    radarMap: '情緒識別雷達圖',
    enterApplicantsName: '請輸入申請人姓名',
    enterTranscript: '請輸入筆錄',
    enterTel: '請輸入11位手機號',
    phoneError: '手機號輸入錯誤',
    signatureNotCompleted: '還沒有完成簽名',
    minutes: '分鍾',
    emotionalRecognition: '情緒識別'
  },
  index: {
    listCases: '我的案件列表',
    pendingMediationCases: '待調解案件',
    completedCases: '已完成案件',
    all: '全部',
    isMediating: '正在調解',
    searchNumberName: '搜索 編號/姓名',
    searchResults: '搜索結果：共{number}個案件',
    disputeNo: '糾紛編號',
    disputeNo2: '糾紛編號：',
    viewDetails: '查看詳情',
    submitApplication: '申請延期提交',
    applicationCantBeBlank: '申請理由不可爲空',
    listOfInquries: '我的咨詢列表',
    uncompletedConsultation: '未完成咨詢',
    searchByConsultation: '根據咨詢編號搜索',
    consultationNo: '咨詢編號',
    serviceStaff: '服務人員',
    applicationForAppeal: '申請訴求',
    disputeDescription: '糾紛描述',
    registrationTime: '登記時間',
    noData: '暫無數據'
  },
  uploadfile: {
    uploadFiles: '上傳文件',
    sureUpload: '確定上傳',
    classification: '分類',
    selectFile: '選擇文件',
    clickUpload: '點擊上傳',
    tip: '提示：當前糾紛爲',
    suggestedEvidence: '建議的證據有',
    limitedSize: '建議上傳png、pdf、doc，docx, jpg等格式文件，且文件不超過20M',
    selectCategory: '請選擇分類',
    selectMaterial: '請選擇材料名稱',
    uploadedFileSize: '上傳文件大小不能超過 20MB',
    uploadSuccessfully: '上傳成功',
    errorFileUploaded: '更新上傳文件出錯，請重新上傳',
    cantExceed20M: '上傳文件不超過20M',
    cantExceed500kb: '上傳文件不超過500kb',
    refreshAndDownloadAgain: '文件已更新，請點擊刷新後重新下載'
  },
  videoRecord: {
    participants: '參會人',
    uploadTime: '上傳時間',
    download: '播放、下載',
    enterDetails: '請填寫詳細內容',
    record: '筆錄',
    haveAgreed: '已同意',
    haveRejected: '已拒絕',
    scanQRCode:
      '您的調解已完成，若對于調解筆錄/調解協議，無異議，請用微信掃描二維碼，前往微信小程序，進行手寫簽名確認操作，以確保您的合法權益',
    limitedString: '長度在 2 到 5 個字符',
    selectProvincial: '請選擇省市區',
    selectGender: '請選擇性別',
    enterDetailedAddress: '請填寫詳細地址'
  },
  bookMeeting: {
    mediator2: '調解人員',
    mediator: '調解人員（視頻調解最多支持8人）',
    petitionAgent: '信訪代理人',
    mediationTime: '調解時間',
    now: '現在',
    reservationTime: '預約時間',
    selectDate: '選擇日期',
    selectTime: '選擇時間點',
    mediationLocation: '調解地點',
    reservationAddress: '預約地址',
    confirm: '確 定',
    cancel: '取消',
    plselectDate: '請選擇日期',
    plselectTime: '請選擇時間',
    selectOneApplicant: '請至少選擇一個申請人',
    selectOneRespondent: '請至少選擇一個被申請人',
    selectOneParty: '請至少選擇一個當事人',
    requiredEnterTel: '該當事人需填寫手機號後才可被預約調解',
    reservationSucceed: '預約成功',
    mediationSucceed: '調解成功!',
    noRealNameAuthentication: '(未實名)',
    invalidDocument: '作廢文書',
    invalidReason:
      '作廢當前文書，該文書將被丟棄。需要調解員重新生成文書併簽署。作廢原因：',
    invalidPlaceholder: '請輸入作廢原因',
    orPreview: '文件不可以預覽',
    insuccess: '作廢成功！',
    infail: '作廢失败！'
  },
  workbench: {
    HasBeenCanceled: '已取消',
    accountType: '賬號類型',
    continue: '繼續',
    organizationsRepresentative: '機構代表人',
    physicalDiscomfort: '身體不適',
    muchWork: '近期工作多',
    noRelevantExperience: '個人沒有相關經驗',
    notSuitableOrganization: '糾紛不適合本機構',
    next: '下一步，填寫調解方案',
    applicant: '申請方',
    respondent: '被申請方',
    legalRepresentative: '法定代表人',
    enterLegalRepresentative: '請輸入法定代表人',
    enterOrganizationRepresentative: '請輸入機構代表人',
    socialCreditCode: '社會信用代碼',
    enterSocialCreditCode: '請輸入社會信用代碼',
    IDIncorrect: '身份證號不正確',
    tel: '手機號碼',
    tel2: '手機號碼：',
    enterTel: '請輸入手機號碼',
    email: '電子郵箱：',
    email2: '電子郵箱',
    address: '住址',
    enterEmail: '請輸入電子郵箱',
    formatIncorrect: '郵箱格式不正確',
    enterAgentsName: '請輸入代理人姓名',
    enterAgentsTel: '請輸入代理人電話',
    enterAgentsIDNumber: '請輸入代理人身份證號',
    enterIDNumber: '請輸入18位身份證號',
    enterRespondentsName: '請輸入被申請人姓名',
    enterCorrectTel: '請輸入正確的手機號碼',
    telIncorrect: '手機號碼不正確',
    mainFacts: '糾紛主要事實，爭議事項：',
    followingAgreements: '經調解，自願達成如下協議：',
    writieMediationOrganization:
      '當事人已書面同意本調解組織適用無異議調解認可制度。先就本糾紛提出以下調解方案：',
    mediationProcess: '調解過程：',
    afterMediation: '經調解，當事人無爭議的事實如下：',
    haveSigned: '皆已簽署',
    residenceAddress: '常住地址',
    residenceAddress2: '常住地址：',
    organizationAddress: '單位地址',
    organizationAddress2: '單位地址：',
    groupAddress: '機構地址',
    whetherToContinue:
      '聯系方式爲固話，文書發起後無法收到並簽署文書, 是否繼續？',
    sendSave: '發送的同時完成保存操作, 是否繼續?',
    enterCorrectInformation: '信息驗證未通過，請填寫正確的信息',
    save: '發送成功的同時完成保存操作, 是否繼續？',
    errorInSigning: '簽名出錯'
  },
  status: {
    detailedReasons: '詳細原因：',
    other: '其它',
    reason: '原因',
    confirmMediationAgreement: '雙方都確認調解協議',
    dontReachMediationAgreement: '雙方調解協議未達成一致',
    applicantWantMediation: '申請人不想調解',
    respondentWantMediation: '被申請人不想調解',
    mediationSucceed: '案件調解成功！',
    selectStatus: '請選擇狀態',
    plaintiffsName: '原告姓名',
    plaintiffsContactNumber: '原告聯系電話',
    defendantsName: '被告姓名',
    DefendantsContactNumber: '被告聯系電話',
    mediationNotes: '調解情況備注：',
    fillMediationNotes: '請填寫調解備注',
    didntAgree: '雙方調解協議未達成一致',
    applicantDoesntWantMediation: '申請人不想調解',
    respondentDoesntWantMediation: '被申請人不想調解',
    plaintiffRequestsForClosure: '原告要求終結',
    defendantRequestsForClosure: '被告要求終結',
    cantDeliverToDefendant: '被告無法送達'
  },
  judicial: {
    claimMatters: '請求事項',
    claimMatters2: '請求事項：',
    factsAndReasons: '事實與理由',
    factsAndReasons2: '事實與理由：',
    courtAcceptedApplication: '申請受理法院：',
    selectCourt: '請選擇受理法院',
    caseType: '案件類型',
    selectCaseType: '請選擇案件類型',
    selectCause: '請選擇案由',
    causeAction: '案由：',
    civil: '民事',
    guangzhou: '廣州互聯網法院',
    selectCourtCase: '請選擇 受理法院 和 案件類型',
    reselect: '當前法院和案件類型下沒有案由，請重新選擇',
    entrustedAgent: '委托代理人',
    turnOnSpeechRecognition: '開始語音識別',
    description:
      '說明：調解成功後,本系統將就本案自動向法院申請撤案。撤回立案申請不影響後續向法院申請司法確認或出具調解書。',
    description2:
      '本人同意司法機關在海南法院涉外民商事法庭案件多元化解平臺上向本人電子送達法律文書（包括但不限於司法確認民事裁定書或民事調解書）。送達地址以調解協議填寫為準。'
  },
  caseInfo: {
    sureToDelete: '確定要刪除嗎？',
    duringMediation:
      '調解過程中，刪除當事人會導致與已發送的文書中的當事人不一致'
  },
  partyBook: {
    applicant: '申請人1',
    mainFacts: '糾紛主要事實，爭議事項不能爲空',
    uponMediation: '經調解，自願達成如下協議不能爲空',
    description1:
      '說明：1.調解成功後,本系統將就本案自動向法院申請撤案。撤回立案申請不影響後續向法院申請司法確認或出具調解書。',
    description2:
      '2.本人同意司法機關在廣州法院在線涉港澳糾紛多元化解平台上向本人電子送達法律文書（包括但不限于司法確認民事裁定書或民事調解書)。送達地址以調解協議填寫爲准。',
    mediationProgramme: '調解方案不能爲空',
    haveObjections: '有異議',
    agreeSave: '同意並保存',
    dissidentsName: '請輸入異議人姓名',
    dissident: '異議人',
    incorrectEmailAddress: '電子郵箱不正確',
    mailingAddress: '郵寄地址',
    objectionsDescription: '異議描述',
    commitmentMediationProgramme: '無異議調解方案承諾書',
    statementProtest: '異議書',
    requiredFields: '有必填項未填寫'
  },
  //   infocenter
  serviceinfo: {
    personalCenter: '個人中心',
    individualImformation: '個人信息',
    edit: '編輯',
    avatar: '頭像',
    basicInformation: '基本資料',
    politicalStatus: '政治面貌',
    IDNumber: '身份證號',
    uploadIDCard: '身份證上傳',
    front: '正面',
    reverseSide: '反面',
    name: '姓名',
    gender: '性別',
    dateOfBirth: '出生日期',
    contactPhone: '聯系手機',
    contactEmail: '聯系郵箱',
    landline: '固定電話',
    degreeOfEducation: '文化程度',
    occupationInformation: '職業資料',
    areasOfExpertise: '擅長領域',
    qualificationCertificate: '資格證書',
    uploadTheCertificate: '證書上傳',
    occupation: '職業',
    workingOrganization: '工作機構',
    workAddress: '工作地址',
    detailAddress: '詳細地址',
    timeToStartWorking: '開始工作時間',
    careerExperience: '從業經曆',
    platformFunction: '平台職能',
    typeOfFunction: '職能類型',
    serviceOrganization: '服務機構',
    serviceArea: '服務地區',
    delete: '刪除',
    add: '添加',
    save: '保存',
    phoneNumberFormatError: '手機號格式錯誤',
    wrongIDNumberFormat: '身份證號格式錯誤',
    enterName: '請輸入姓名',
    enterPhoneNumber: '請輸入手機號',
    selectFunctionType: '請選擇職能類型',
    selectServiceOrganization: '請選擇服務機構',
    selectServiceArea: '請選擇服務地區',
    CommunistPartyofChina: '中共黨員',
    ProbationaryPartyMembers: '中共預備黨員',
    leagueMember: '共青團員',
    MDC: '民革黨員',
    CDL: '民盟盟員',
    CDNCA: '民建會員',
    DPP: '民進會員',
    CPWDP: '農工黨黨員',
    thePublicParty: '致公黨黨員',
    JiusanSocietyMembers: '九三學社社員',
    TDSL: '台盟盟員',
    nonpartyPersonage: '無黨派人士',
    ordinaryResident: '普通居民',
    editPersonalInformation: '編輯個人信息成功',
    militaryOfficerCard: '軍官證',
    passport: '護照'
  },
  setaccount: {
    accountType: '帳號類型',
    accountSetting: '帳號設置',
    newAccountNumber: '新帳號',
    newAccountNumber2: '新帳號（手機號）',
    enternewAccountNumber: '請輸入新帳號（手機號）',
    mobilePhoneNumber: '手機號',
    verificationCode: '驗證碼',
    getTheVerificationCode: '獲取驗證碼',
    enterNewAccount: '請輸入新帳號',
    enterTheSMSVerificationCode: '請輸入簡訊/信箱驗證碼',
    resend: '重新發送',
    modifyPasswordSuccessfully: '修改手機號成功，即將跳轉到首頁'
  },
  setpwd: {
    modifyPassword: '修改密碼',
    oldPassword: '舊密碼',
    newPassword: '新密碼',
    confirmPassword: '確認密碼',
    inconsistentPasswordsEntered: '兩次輸入密碼不一致',
    pleaseEnter: '請輸入8-16位，需包含大小寫字母、數字和特殊符號',
    enterOldPassword: '請輸入舊密碼',
    enterNewPassword: '請輸入8-16位，需包含大小寫字母、數字和特殊符號',
    enterPasswordAgain: '請再次輸入密碼',
    modifyPasswordSuccessfully: '修改密碼成功，即將跳轉到首頁',
    organizationInformation: '機構信息'
  },
  orginfo: {
    organizationsName: '機構名稱',
    administrativeLevel: '行政級別',
    administrativeLevel2: '行政級別：',
    pleaseSelect: '請選擇',
    superiorOrganization: '上級單位',
    superiorOrganization2: '上級單位：',
    telephoneLandline: '電話座機',
    telephoneLandline2: '電話座機：',
    groupAddress: '機構地址',
    groupAddress2: '機構地址：',
    affiliatedLocation: '所屬地區',
    organizationType: '機構類型',
    organizationCode: '組織機構代碼',
    organizationCode2: '組織機構代碼：',
    organizationCodeCertificate: '組織機構代碼證',
    provincial: '省級',
    municipalLevel: '市級',
    districtCountyLevel: '區/縣級',
    court: '法院',
    generalOrganization: '普通機構',
    selectOrganizationType: '請選擇機構類型',
    enterTheOrganizationAddress: '請輸入機構地址',
    enterTheTelephoneLandline: '請輸入電話座機',
    selectAffiliatingArea: '請選擇所屬地區',
    editingSucceed: '機構信息編輯成功'
  },
  //   statAnalysis
  platformap: {
    statisticalAnalysis: '統計分析',
    disputeMap: '糾紛地圖',
    selectDate: '選擇日期',
    startDate: '開始日期',
    endingDate: '結束日期',
    inquire: '查詢',
    selectCity: '選擇城市',
    pleaseSelectCity: '請選擇城市',
    export: '導出',
    allStreets: '所有街道',
    street: '街道',
    numberOfDisputeMediationInTheStreet: '街道的糾紛調解數量',
    numberOfDisputeMediation: '機構糾紛調解數量',
    TrendOfGuangzhou: '海口市調解走勢',
    number: '序號',
    organizationsName: '機構名稱',
    administrator: '管理員',
    contactWay: '聯系方式',
    mediatorsWithinTheEstablishment: '在編調解員',
    numberOfDisputes: '糾紛數量',
    previousPage: '上一頁',
    nextPage: '下一頁',
    numberOfUserRegistrations: '用戶注冊量',
    numberOfMediationOrganizations: '調解機構數',
    numberOfMediators: '調解員數量',
    numbeMediationCases: '調解案件量',
    numberOfSuccessfulMediation: '調解成功數量',
    failedMediationsAmount: '調解失敗數量',
    numberOfJudicialConfirmations: '司法確認案件數量',
    totalNumberOfLitigationCases: '訴訟案件總量',
    totalConsultations: '咨詢總量',
    mediate: '調解',
    consult: '咨詢',
    judicial: '司法確認',
    litigation: '訴訟',
    arbitration: '仲裁'
  },
  userstatistics: {
    userStatisticsList: '用戶統計列表',
    totalVisits: '訪問總量',
    numberOfRegisteredUsers: '注冊量',
    serviceStaff: '服務人員',
    serviceOrganization: '服務機構',
    accessingUserVolumeStatistics: '訪問用戶量統計',
    statisticsOfRegisteringUsers: '注冊用戶統計',
    serviceStaffStatistics: '服務人員統計',
    resourceMap: '資源地圖',
    thematicAnalysisOfDisputes: '專題報告'
  },
  disputesubject: {
    typedCases: '類型案件',
    analysisOfConsultationTrend: '咨詢走勢分析',
    analysisOnMediationCasesTrend: '調解案件走勢分析',
    analysisOfTheMediationCases: '街道調解案件數量分析',
    parameterDimensionAnalysis: '調解案件參數維度分析',
    applicantRoleAnalysis: '申請人角色分析',
    mediationStatusAnalysis: '調解狀態分析',
    analysisOfMediationResult: '調解結果分析',
    variousTypesOfDisputeMediation: '各街道各類型糾紛調解數據',
    selectOneDisputeType: '請選擇至少一種糾紛類型',
    disputesHaveBeenSelected: '已選擇{number}糾紛類型',
    numberOfConsultations: '咨詢案件數量',
    numberOfCases: '咨詢轉調解案件數量',
    proportion: '咨詢轉調解比例',
    waitingForAcceptance: '等待受理',
    waitingMediation: '等待調解',
    inMediation: '調解中',
    ended: '已結束',
    individual: '個人',
    legalPerson: '法人',
    unincorporatedOrganization: '非法人組織',
    closed: '已結案',
    mediationSucceed: '調解成功',
    mediationFailed: '調解失敗',
    withdrawCase: '撤回案件'
  },
  //   admin
  role: {
    rolePermission: '角色權限',
    rolePermission2: '角色權限：',
    roleManagement: '角色管理',
    roleType: '角色類型：',
    roleType2: '角色類型',
    newRoleName: '新增角色名稱',
    roleName: '角色名稱',
    roleName2: '角色名稱：',
    creater: '創建人',
    creationTime: '創建時間',
    remark: '備注',
    remark2: '備注：',
    operate: '操作',
    view: '查看',
    modify: '修改',
    counselor: '咨詢師',
    customerService: '客服',
    judge: '法官',
    newOrganization: '新增機構'
  },
  roleEdit: {
    roleInformation: '角色信息',
    roleCode: '角色代碼：',
    selectOnePermission: '請至少選擇一個權限',
    enterRoleName: '請輸入角色名稱',
    enterRoleCode: '請輸入角色代碼',
    enterRoleType: '請輸入角色類型',
    normalUser: '普通用戶',
    modifyingRuleSucceed: '修改角色成功',
    addingRoleSucceed: '添加角色成功'
  },
  organizationEdit: {
    organizationManagement: '機構管理',
    organizationInformation: '機構信息',
    organizationsName: '機構名稱',
    organizationType: '機構類型',
    administrativeLevel: '行政級別',
    organizationsContacts: '機構聯系人',
    organizationsContacts2: '機構聯系人：',
    mediationType: '調解類型',
    mediationType2: '調解類型：',
    contactsTelephone: '聯系人手機號',
    contactsTelephone2: '聯系人手機號：',
    superiorOrganization: '上級單位',
    organizationCode: '組織機構代碼',
    telephoneLandline: '電話座機',
    groupAddress: '機構地址',
    organizationCertificate: '組織機構證書：',
    enterOrganization: '請輸入機構名稱',
    enterOrganizationalContact: '請輸入機構聯系人',
    enterContactsPhone: '請輸入聯系人手機號',
    selectAdministrativeLevel: '請選擇行政級別',
    selectOrganizationType: '請選擇機構類型',
    selectMediationType: '請選擇調解類型',
    enterTheTelephoneLandline: '請輸入電話座機',
    selectTypeOfDispute: '請選擇糾紛類型',
    selectOrganizationAddress: '請選擇機構地址',
    lawOffice: '律所',
    addingOrganizationSucceed: '添加機構成功',
    modifyingOrganizationSucceed: '修改機構成功'
  },
  accountEdit: {
    accountManagement: '帳戶管理',
    workersAccountInformation: '工作人員帳戶信息',
    basicInformation: '基本資料',
    politicalStatus: '政治面貌',
    contactEmail: '聯系郵箱',
    degreeOfEducation: '文化程度',
    dateOfBirth: '出生日期：',
    occupationInformation: '職業資料',
    separateWithCommas: '請用中文逗號隔開，如：婚姻糾紛，財産分配',
    qualificationCertificate: '資格證書',
    typeOfOccupation: '職業類型',
    workAddress: '工作地址',
    careerExperience: '從業經曆',
    platformFunctionRoles: '平台職能角色',
    affiliatedOrganization: '所屬機構',
    selectSubsidiaryOrganization: '請選擇所屬機構',
    affiliatedArea: '所屬區域',
    selectArea: '請選擇所屬區域',
    selectOrganization: '請選擇機構',
    separateAreasOfExpertise: '擅長領域請用中文逗號分隔',
    wrongIDNumberFormat: '身份證號格式錯誤',
    enterName: '請輸入姓名',
    enterPhoneNumber: '請輸入手機號',
    selectRoleType: '請選擇角色類型',
    selectRoleName: '請選擇角色名稱',
    modifyingWorkerSucceed: '修改工作人員成功',
    addingWorkerSucceed: '添加工作人員成功'
  },
  account: {
    accountStatus: '賬號狀態',
    accountStatus2: '賬號狀態：',
    inUse: '使用中',
    deactivated: '已停用',
    deactivation: '停用',
    startUsing: '啓用',
    paused: '已暫停',
    noData: '查無數據',
    statusModificationSucceed: '狀態修改成功',
    addAccount: '新增賬戶'
  },
  abilityTempleEdit: {
    1: '新建模板',
    templateName: '模板名稱',
    assessmentCycle: '評估周期',
    applicableObjects: '適用對象',
    indexWeight: '指標權重',
    sumWeights: '(權重之和應爲100%)',
    assessmentIndicators: '評估指標',
    indexDescription: '指標說明',
    index: '指標權',
    enterWeights: '請輸入權重(例：20%)',
    getProcessingRate: '處理率=已調解案件數/（已調解案件數+正在調解案件數）',
    getSuccessRate: '成功率=案件調解成功數/已調解案件數',
    assessmentResult: '評估結果',
    score: '得分',
    grade: '等級',
    example: '(例：0~50)',
    enterTemplateName: '請輸入模板名稱',
    selectAssessmentCycle: '請選擇評估周期',
    selectApplicableObject: '請選擇適用對象',
    processingRate: '處理率',
    SuccessRateOfMediated: '該周期內已調解案件成功率',
    satisfaction: '滿意度',
    partiesSatisfaction: '評估周期內當事人對調解過程的滿意度',
    successRate: '成功率',
    duringTheAssessmentCycle: '估周期內已調解案件成功率',
    fillInformation: '請把模板信息填寫完整哦'
  },
  abilityTemple: {
    competencyAssessmentAnalysis: '能力評估分析',
    whetherContinue: '此操作將永久刪除該文件, 是否繼續?',
    deletionCanceled: '已取消刪除'
  },
  //  consultant
  finishDetail: {
    completedConsultation: '已完成咨詢',
    consultationDetails: '咨詢詳情',
    inAConversation: '與xxx的交談中',
    caseNo: '案件編號',
    caseType: '案件類型',
    viewDisputeDetails: '查看糾紛詳情',
    consultationIsEnd: '咨詢已結束',
    pleaseEnter: '請輸入內容',
    consultationTime: '咨詢時間',
    MondayToFriday: '（周一至周五9:00-18:00）',
    listOfEvidence: '證據列表',
    attachmentsDownloadSucceeded: '附件下載成功'
  },
  detail: {
    calculator: '計算器',
    sendingFiles: '發送文件',
    clickUpload: '點擊上傳',
    canBeUploaded: '只能上傳doc/docx/png/jpg/txt文件',
    total: '共(0)條',
    inVoice: '語音中',
    voiceNotSupported: '當前浏覽器不支持語音轉文字',
    reuploadFile: '請重新上傳文件',
    uploading: '正在上傳，請稍後',
    errorFileUploaded: '更新上傳文件出錯，請重新上傳',
    uploadSuccessfully: '上傳成功',
    selectFirst: '請先選擇文件',
    mediated: '已調解'
  },
  //   dtuMediation
  peoMediation: {
    applicationNotice: '申請須知',
    tip1:
      '1.請您根據真實發生的糾紛情況如實登記信息，爲了更好地爲您服務，請您確認填寫信息的正確和完整。',
    tip2:
      '2.在您申請調解後三天內，將由調解機構管理員決定是否受理並爲您分配相應的調解員，調解員將電話聯系您了解糾紛情況。案件全流程將進行短信通知，請您保持電話暢通。',
    tip3:
      '3.代理人是以被代理人名義進行代理活動的人。若您填寫您的代理人。該代理人將在您的授權範圍內以您的名義進行本次調解相關的民事活動。填寫糾紛詳情',
    fillDisputeDetails: '填寫糾紛詳情',
    fillApplicantsInformation: '填寫申請人信息',
    fillRespondentInformation: '填寫被申請人信息'
  },
  onlineMediation: {
    fillConsultationInformation: '填寫咨詢信息',
    selectCounselor: '選擇咨詢師',
    evaluateTheCounselor: '咨詢結束並評價咨詢師'
  },
  applyAssess: {
    submitAnApplication: '提交申請',
    applicationForAssessmentReport: '申請評估報告',
    assessmentReportGeneration: '評估報告生成',
    viewEvaluationReport: '查看評估報告'
  },
  //   login
  loginstaff: {
    signInWithPhone: '手機號登錄',
    forgotPassword: '忘記密碼？'
  },
  findpwd: {
    enterPhoneNumber: '請輸入手機號',
    enterEmail: '請輸入郵箱',
    enterVerificationCode: '請輸入驗證碼',
    enterTheSMSVerificationCode: '請輸入短信驗證碼',
    enterTheEmailVerificationCode: '請輸入郵箱驗證碼',
    getSMSVerification: '獲取短信驗證碼',
    getEmailVerification: '獲取郵箱驗證碼',
    enterNewPassword: '請輸入8-16位，需包含大小寫字母、數字和特殊符號',
    enterNewPasswordAgain: '請再次輸入新密碼',
    verifyPhoneNumber: '驗證手機號',
    verifyEmail: '驗證郵箱',
    resetPassword: '重置密碼',
    pleaseEnter: '請輸入8-16位，需包含大小寫字母、數字和特殊符號',
    reenterPassword: '兩次輸入密碼不一致，請重新輸入',
    passwordResetSucceeded: '密碼重置成功, 3秒後跳轉到登錄頁',
    phoneNumberFormatError: '手機號格式錯誤',
    emailFormatError: '郵箱格式錯誤',
    enterGraphicalVerificationCode: '請輸入圖形驗證碼',
    graphicalVerificationCodeError: '圖形驗證碼錯誤',
    resend: '重新發送',
    phoneNumberOrEmailFormatError: '手機號或郵箱格式錯誤'
  },
  //   register
  register: {
    registerWithPhoneNumber: '手機號注冊',
    registerWithEMail: '郵箱注冊',
    enterPhoneNumber: '請輸入手機號',
    enterTheSMSVerificationCode: '請輸入短信驗證碼',
    getTheVerificationCode: '獲取驗證碼',
    enterThePassword: '請輸入密碼',
    agree: '我同意',
    resend: '重新發送',
    register: '注冊',
    emailFormatError: '郵箱格式錯誤',
    activateLogin: '郵件已發送，請前往您的郵箱進行激活登錄',
    registerWithEMailOrPhoneNumber: '請輸入郵箱或手機號'
  },
  ace_api: {
    noCameraDetected: '沒有檢測到攝像頭,請檢測好是否有音視頻設備',
    noCamera: '沒有檢測到攝像頭',
    verificationSucceed: '驗證成功',
    browserDoesntSupport: '您的浏覽器暫時不支持獲取用戶'
  },
  info: {
    basicInformation: '基本資料',
    currentAvatar: '當前頭像：',
    fileLimited: '僅支持png、jpg圖片文件，且文件應小于1M',
    realName: '真實姓名：',
    currentResidenceArea: '現居地區：',
    detailAddress: '詳細地址：',
    permanentResidenceAddress: '戶籍地址：',
    onlyBeFormat: '上傳頭像圖片只能是 JPG或者PNG 格式',
    cantExceed1MB: '上傳頭像圖片大小不能超過 1MB!',
    male: '男',
    female: '女',
    other: '其他',
    enterIDNumber: '請輸入身份證'
  },
  security: {
    yourSecurityLevel: '您的安全等級',
    securityLevel: '安全等級',
    completeAllBindings: '完成全部綁定，提升賬戶安全',
    identityAuthentication: '身份認證',
    improveAccountSecurity:
      '提升賬戶安全級別和信任級別，認證後將無法修改認證信息',
    bindPhone: '綁定手機',
    improveSecurity: '綁定手機，可以提高安全性及找回密碼等功能',
    bindEmail: '綁定郵箱',
    bindEmailHelp: '綁定郵箱，可以提高安全性和信息的通知',
    modifyPassword: '修改密碼',
    modifyMail: '修改郵箱',
    newMail: '新郵箱',
    originalPassword: '原密碼不能爲空',
    originalPas: '原密碼',
    enterOriginalPas: '請輸入原密碼',
    enterMail: '請輸入郵箱地址',
    newPas: '新密碼',
    newPasswordCantBeBlank: '新密碼不能爲空',
    confirmPasswordBlank: '確認密碼不能爲空',
    modifyBindingPhone: '修改綁定手機號',
    moreThan8Digits: '設置包含數字和字母，長度應爲8位以上',
    enterPasswordAgain: '請再次輸入密碼',
    inconsistentPasswordsEntered: '兩次輸入密碼不一致',
    enterPhoneNumber: '請輸入手機號',
    telFormatIncorrect: '手機號格式不正確',
    certified: '已認證',
    setUp: '設置',
    enterCorrectEmailAddress: '請輸入正確的郵箱地址',
    goauthentication: '去認證',
    validationDidntPass: '表單驗證未通過',
    cantBeTheSameAsTheOriginals: '新手機號不能與原手機號相同',
    newPhone: '新手機',
    hasBeenCertified: '已實名',
    modificationSucceed: '修改成功',
    score: '分'
  },
  centerTwo: {
    inProgress: '評估報告進行中',
    application: '評估報告申請完成',
    assessmentProgress: '評估進度',
    noAssessmentRequested: '評估未申請',
    applicationForAssessmentReport: '申請評估報告',
    generateTheAssessmentReport: '生成評估報告',
    viewEvaluationReport: '查看評估報告',
    noAssessmentReportRequested: '評估報告未申請',
    assessmentReport: '評估報告申請中',
    initiateTheAssessment: '發起評估',
    judicialConfirmation: '司法確認'
  },
  centerSix: {
    enterQueryPassword: '輸入查詢密碼',
    queryPassword: '查詢密碼',
    enterTheQueryPassword: '請輸入查詢密碼',
    caseStatus: '案件狀態',
    causeActionType: '案由類型',
    courtForApplication: '申請法院',
    applicantsAppeal: '申請人訴求',
    applicationForMediation: '調解申請書詳情',
    mediationApplicationApplication: '調解申請書申請',
    waitingForConfirmation: '等待確認',
    accepting: '受理中',
    confirmEffectiveness: '確認有效',
    filingProgressInquiry: '立案進度查詢'
  },
  centerSeve: {
    ApplyJudicialConfirmation: '申請司法確認',
    consultationProgress: '咨詢進度'
  },
  centerOne: {
    viewRecords: '查看記錄',
    manualConsultation: '人工咨詢',
    fillApplication: '填寫申請',
    consultationEnds: '結束咨詢',
    initiateTheConsultation: '發起咨詢',
    applicationForLitigation: '訴訟申請'
  },
  centerFour: {
    proceedingDetails: '訴訟詳情',
    registrationTime: '登記時間',
    fileACaseOnline: '在線申請立案',
    waitingForAcceptance: '等待受理',
    filingSucceed: '立案成功',
    accessToLitigation: '進入訴訟',
    detailsOfJudicialConfirmation: '司法確認詳情'
  },
  centerFive: {
    registrationTime: '登記時間：'
  },
  registration: {
    disputeList: '糾紛登記列表',
    addDispute: '添加糾紛',
    myDispute: '我的糾紛登記'
  },
  //   mediator
  judicialConfirm: {
    naturalPerson: '自然人：',
    legalPerson: '法人：',
    unincorporatedOrganization: '非法人組織：',
    organiztionsName: '單位名稱：',
    ApplyJudicialConfirmation: '申請司法確認',
    basicInformation: '基本信息',
    courtAcceptedApplication: '申請受理法院',
    caseType: '案件類型',
    caseType2: '案件類型：',
    partysBasicInformation: '當事人基本信息',
    required: '必填',
    instrumentDeliveryAddress: '文書送達地址',
    instrumentDeliveryAddress2: '文書送達地址：',
    fillInstrumentDeliveryAddress: '請務必填寫文書送達地址',
    notes: '注意：法人和非法人組織機構代碼和注冊登記號都取調解中的統一信用代碼',
    fillOrganizationsName: '請填寫單位名稱',
    organizationsNature: '單位性質：',
    organizationCode: '組織機構代碼',
    registrationNumber: '注冊登記號：',
    enterRegistrationNumber: '請輸入注冊登記號',
    legalRepresentative: '法定代表人',
    principalPersonInCharge: '主要負責人',
    principalPersonInCharge2: '主要負責人：',
    organizationCodeFormatError: '組織機構代碼格式錯誤',
    registrationNumberFormatError: '注冊登記號格式錯誤',
    onlineDelivery: '在線送達',
    mailDelivery: '郵寄送達',
    selectResidentArea: '請選擇常住地區',
    selectOrganizationAddress: '請選擇單位地址',
    enterAddress: '請輸入文書送達地址',
    enterOrganiztionsName: '請輸入單位名稱',
    enterRequest: '請輸入請求內容',
    operateAgain: '表單信息輸入不正確，請重新操作',
    evidenceCompletedOrBlank: '每條證據材料必須填寫完整或者都爲空',
    queryPasswordEnter: '查詢密碼必須輸入',
    judicialConfirmationSubmissionSucceed: '司法確認提交成功',
    mediationAgreement: '調解協議書',
    certificateOfJudicialConfirmation: '司法確認書',
    applicationJudicialConfirmation: '司法確認申請書',
    partysCertification: '當事人身份證明',
    fillIDNumber: '請填寫證件號碼',
    fillPhoneNumber: '請填寫手機號碼'
  },
  dossier: {
    listCases: '我的案件列表',
    casesMediated: '已調解案件',
    caseDetails: '案件詳情',
    electronicFiles: '電子卷宗',
    disputeNo: '糾紛編號',
    identityStatus: '狀態：',
    fileProgress: '卷宗進度',
    uploadMaterials: '上傳資料',
    generateTheFile: '生成卷宗',
    catalogueInVolume: '卷內目錄',
    fileCover: '卷宗封面',
    volumeName: '卷名',
    agreementNo: '協議編號',
    mediationDate: '調解日期',
    filingPeople: '立卷人：',
    filingDate: '立卷日期：',
    auditor: '審核人：',
    withdrawFile: '撤回卷宗',
    archiveFiles: '歸檔卷宗',
    withdrawalFiles: '撤回卷宗將清除卷宗記錄和卷宗區文件。',
    reconfirmWhetherToSubmit: '再次確認是否提交，一旦提交無法修改。',
    revokeFile: '撤銷卷宗',
    auditFailed: '審核失敗',
    newFile: '卷宗新增',
    fileModification: '卷宗修改',
    archived: '已歸檔',
    auditSucceed: '審核成功',
    identityCertificate: '身份證明',
    listOfEvidence: '證據清單',
    clericalMaterials: '文書材料',
    letterAuthorization: '授權委托書',
    partysCertification: '當事人身份證明',
    agentsIdentification: '代理人身份證明',
    defaultAttachments: '默認附件',
    applicationMediation: '調解申請書',
    notice: '當事人權利義務告知書',
    mediationTranscript: '調解筆錄',
    investigationTranscript: '調查筆錄',
    mediationAgreement: '調解協議書',
    performanceProof: '調解協議履行證明',
    applicationJudicialConfirmation: '司法確認申請書',
    mediationReturnRecords: '調解回訪記錄',
    closingTable: '結案表',
    evidenceMaterial: '調解證據材料',
    selectCategory: '請選擇分類',
    selectMaterial: '請選擇材料名稱',
    uploadFileFirst: '請先上傳文件',
    withdrawalSucceed: '撤回成功',
    sentSuccessfully: '發送成功',
    notes: '備注',
    promptMessage: '提示信息'
  },
  detailold: {
    pendingMediationCases: '待調解案件',
    completedCases: '已完成案件',
    disputeDetails: '糾紛詳情',
    reserveMeeting: '預約會議',
    workbench: '工作台',
    reassign: '重新分配',
    mediationAgreement: '調解協議',
    NoobjectionMediation: '無異議調解方案',
    NoncontroversialFactsConfirmation: '無爭議事實確認協議',
    applicationJudicialConfirmation: '司法確認申請書',
    electronicFiles: '電子卷宗',
    followUpPhase: '後續階段',
    mediationStatus: '調解狀態',
    applicationForAssessmentReport: '申請評估報告',
    mediationRecords: '調解記錄',
    participant: '參會者',
    mediationName: '調解名',
    enterVideo: '進入視頻',
    assessmentReport: '評估報告',
    uploadFiles: '上傳文件',
    assessmentReportBook: '評估報告書',
    peopleMediation: '人民調解',
    administrativeMediation: '行政調解',
    arbitrationMediation: '仲裁調解',
    judicialMediation: '司法調解',
    commercialMediation: '商業調解',
    lawyerMediation: '律師調解',
    notaryMediation: '公證調解',
    professionalMediation: '專業調解',
    industryMediation: '行業調解',
    deletingThePeople: '是否繼續刪除該案件人',
    continueDeletingfile: '是否繼續刪除該文件',
    deletionCanceled: '已取消刪除'
  },
  detailRecord: {
    playDownload: '播放、下載',
    clickPlay: '點擊播放 或 右擊鏈接另存爲'
  },
  applicantdata: {
    socialCreditCode: '社會信用代碼',
    enterUnifiedSocialCreditCode: '請輸入統一社會信用代碼',
    fillOrganizationsName: '請填寫單位名稱',
    fillApplicantsName: '請填寫申請人姓名',
    socialCreditCodeError: '社會信用代碼輸入錯誤',
    enterOrganiztionsName: '請輸入單位名稱',
    enterOrganization: '請輸入機構名稱',
    enterOrganizationRepresentative: '請輸入機構代表人',
    fillRespondentsName: '請填寫被申請人姓名'
  },
  //   organcenter
  distribution: {
    mediator1: '調解員：',
    organizationsManagementCenter: '機構管理中心',
    caseAssignment: '案件分配列表',
    enterNameNumberCase: '請輸入姓名/編號/糾紛類型',
    search: '搜索',
    disputeType: '糾紛類型',
    expand: '展開',
    hide: '收起',
    registrationTime: '登記時間',
    sure: '確定',
    startDate: '開始日期',
    endingDate: '結束日期',
    searchResults: '搜索結果',
    disputeNo: '糾紛編號：',
    mediator: '調解員',
    accept: '受理',
    notAccept: '不受理',
    allotMediators: '分配調解員',
    reallotMediators: '重新分配調解員',
    transferMediationOrganization: '轉移調解機構',
    mediationProgress: '調解進度',
    disputeOccurred: '糾紛發生地',
    applicant: '申請人',
    applicantsAgent: '申請人代理人',
    respondent: '被申請人',
    respondentsAgent: '被申請人代理人',
    viewDetails: '查看詳情',
    mediationOrganization: '調解機構',
    chooseMediator: '選擇調解員',
    enterMediatorsName: '請輸入調解員姓名',
    enterMediators: '請輸入調解員',
    choose: '選擇',
    progressDetails: '進度詳情',
    currentStatus: '當前狀態：',
    importantTips: '重要提示',
    acceptTheCase:
      '請您根據真實發生的糾紛情況決定是否受理該案件，若您選擇“不受理”，將導致申請人無法享受本機構提供的調解服務。',
    notAcceptTheCase:
      '請您根據真實發生的糾紛情況決定是否受理該案件，若您選擇“受理”，本機構調解員將爲案件提供調解服務。',
    notAcceptCase: '不受理案件',
    reason: '原因',
    detailedReasons: '詳細原因',
    transferOrganization: '轉移機構',
    enterReasonsTransfer: '請先填寫轉出原因(必填)',
    selectType: '請選擇類型',
    enterOrganization: '請輸入機構名稱',
    transfer: '轉出',
    notUnderOrganization: '非本機構管轄',
    otherOrganizationsAccepted: '其他機構已受理/解決',
    mediationIsntGranted: '依案件性質不予調解',
    otherReasons: '其他原因',
    all: '全部',
    waitingMediation: '等待調解',
    isMediating: '正在調解',
    allTime: '所有時間',
    withinAWeek: '一周內',
    withinAMonth: '一月內',
    withinAYear: '一年內',
    customTime: '自定義時間',
    mediationTypes: '所有調解類型',
    peopleMediation: '人民調解',
    administrativeMediation: '行政調解',
    asssignMediatorSuccessfully: '分配調解員成功',
    transferMediationOrganizationSuccessfully: '轉移調解機構成功',
    rejectSuccessfully: '不受理成功',
    acceptSuccessfully: '受理成功',
    allTypes: '所有類型'
  },
  addservice: {
    addServiceStaff: '添加服務人員',
    basicInformation: '基本資料',
    politicalStatus: '政治面貌',
    IDNumber: '身份證號',
    uploadIDCard: '身份證上傳',
    front: '正面',
    reverseSide: '反面',
    contactPhone: '聯系手機',
    contactEmail: '聯系郵箱',
    degreeOfEducation: '文化程度',
    occupationInformation: '職業資料',
    areasOfExpertise: '擅長領域',
    separateWithCommas: '請用中文逗號隔開，如：婚姻糾紛，財産分配',
    qualificationCertificate: '資格證書',
    uploadTheCertificate: '證書上傳',
    occupation: '職業',
    workingOrganization: '工作機構',
    workAddress: '工作地址',
    detailAddress: '詳細地址',
    timeToStartWorking: '開始工作時間',
    careerExperience: '從業經曆',
    platformFunction: '平台職能',
    typeOfFunction: '職能類型',
    serviceOrganization: '服務機構',
    serviceArea: '服務地區',
    add: '添加',
    save: '保存',
    queryServiceStaff: '查詢服務人員',
    enterServiceStaffsTelephone: '請輸入服務人員手機號',
    enterCorrectPhone: '請輸入正確的手機號',
    sure: '確定',
    phoneNumberFormatError: '手機號碼格式錯誤',
    wrongIDNumberFormat: '身份證號格式錯誤',
    separateAreasOfExpertise: '擅長領域請用中文逗號分隔',
    enterName: '請輸入姓名',
    enterPhoneNumber: '請輸入手機號',
    selectFunctionType: '請選擇職能類型',
    selectServiceOrganization: '請選擇服務機構',
    selectServiceArea: '請選擇服務地區',
    CommunistPartyofChina: '中共黨員',
    ProbationaryPartyMembers: '中共預備黨員',
    communistYouthLeague: '共青團員',
    MDC: '民革黨員',
    CDL: '民盟盟員',
    CDNCA: '民建會員',
    DPP: '民進會員',
    CPWDP: '農工黨黨員',
    thePublicParty: '致公黨黨員',
    JiusanSocietyMembers: '九三學社社員',
    TDSL: '台盟盟員',
    nonpartyPersonage: '無黨派人士',
    ordinaryResident: '普通居民',
    modifyingServiceStuffSucceed: '修改服務人員成功',
    addingServiceStaffSucceed: '添加服務人員成功',
    nationality: '請選擇國籍'
  },
  capabilitydetail: {
    assessmentDetails: '評估詳情',
    name: '姓名',
    organization: '機構',
    assessmentCycle: '評估周期',
    assessmentResult: '評估結果',
    totalScore: '總得分',
    grade: '等級',
    processingRate: '處理率',
    weight: '權重',
    caseprocessingRate: '評估周期內案件處理率',
    numberOfCasesMediated: '已調解案件數',
    casesBeingMediated: '正在調解案件數',
    score: '得分',
    successRate: '成功率',
    successRateCasesProcessed: '評估周期內已處理案件成功率',
    numberOfSuccessfulMediation: '調解成功數',
    numberOfAssessments: '評價數',
    satisfaction: '滿意度'
  },
  capabilityevaluate: {
    competencyAssessmentAnalysis: '能力評估分析',
    export: '導出',
    organization: '機構',
    assessmentCycle: '評估周期',
    affiliatedOrganization: '所屬機構',
    assessmentScore: '評估得分',
    assessmentRating: '評估等級',
    operate: '操作',
    view: '查看',
    number: '序號',
    allOrganizations: '全部機構',
    allStaff: '全部人員',
    organizationalCapacityAssessment: '機構能力評估',
    capacityAssessment: '調解員能力評估'
  },
  comfirmlist: {
    organizationsManagementCenter: '機構管理中心',
    judicialConfirmationList: '司法確認列表',
    enterPersonnelName: '請輸入人員姓名',
    search: '搜索',
    mediationType: '調解類型',
    expand: '展開',
    hide: '收起',
    registrationTime: '登記時間',
    sure: '確定',
    disputeNo: '糾紛編號',
    caseStatus: '案件狀態',
    pendingConfirmation: '待確認',
    allocationOfJudges: '分配辦案法官',
    confirm: '確認',
    caseDetails: '案件詳情',
    caseProgress: '案件進度',
    judicialConfirmationCaseNo: '司法確認案號'
  },
  dossierdetail: {
    organizationManagement: '機構管理',
    fileRecords: '卷宗記錄',
    fileDetails: '卷宗詳情',
    fileProgress: '卷宗進度',
    progress: '卷宗進度',
    status: '狀態',
    disputeNo: '糾紛編號',
    fileCatalogue: '卷宗目錄',
    fileCover: '卷宗封面',
    volumeName: '卷名',
    caseNo: '案件編號',
    agreementNo: '協議編號',
    mediator: '調解員',
    mediationDate: '調解日期',
    filingDate: '立卷日期',
    remark: '備注',
    filingPeople: '立卷人',
    auditor: '審核人',
    passAudit: '通過審核',
    backToTheFile: '退回卷宗',
    currentStatus: '當前狀態',
    confirmFileInformation: '確認卷宗信息無誤？通過審核？',
    reasonsForReturn: '退回理由',
    enterReasonForReturn: '請輸入退回理由',
    fileReviewPassed: '卷宗審核通過',
    reviewPassed: '審核通過',
    fileReturnedSuccessfully: '卷宗退回成功',
    catalogueInVolume: '卷內目錄',
    backCover: '封底',
    revokeFile: '撤銷卷宗',
    fileReviewFailed: '卷宗審核失敗',
    newFile: '卷宗新增',
    fileReviewModified: '卷宗審核修改',
    fileHasBeenSubmitted: '卷宗已提交審核',
    fileReviewSucceed: '卷宗審核成功'
  },
  dossierlist: {
    organizationsManagementCenter: '機構管理中心',
    fileRecords: '卷宗記錄',
    no: '編號',
    filingPeople: '立卷人',
    type: '類型',
    time: '時間',
    startDate: '開始日期',
    endingDate: '結束日期',
    fileNo: '卷宗編號',
    applicant: '申請人',
    filingTime: '立卷時間',
    viewDetails: '查看詳情',
    currentOrganization: '當前機構',
    backfillFilterCriteria: '回填當前列表的過濾條件',
    saveFilterCriteria: '保存當前列表的過濾條件'
  },
  mediatelist: {
    caseMediationRecords: '案件調解記錄',
    disputeMediation: '糾紛調解',
    migrated: '已轉移',
    selectRegion: '選擇地區',
    enterNameNumberCase: '請輸入姓名/編號/糾紛類型',
    search: '搜索',
    disputeType: '糾紛類型',
    selectDistrictTown: '請選擇區/鎮',
    selectStreet: '請選擇街道',
    selectProvince: '請選擇省',
    selectCity: '請選擇市',
    listOfProvinces: '省份列表',
    provinces: '省份',
    city: '城市',
    backfillFilterCriteria: '回填當前列表的過濾條件',
    customTime: '自定義時間',
    saveFilterCriteria: '保存當前列表的過濾條件'
  },
  organlist: {
    organizationsAdministrator: '機構管理員',
    serviceOrganizationList: '服務機構列表',
    serviceOrganization: '服務機構',
    mediationMethods: '調解方式',
    mediator: '調解員',
    organizationDetails: '機構詳情',
    details: '機構詳情',
    phone: '電話',
    personInCharge: '責任人',
    personInCharge2: '責任人：',
    address: '地址',
    address2: '地址：',
    contactPhoneNumber: '聯系手機號',
    positionOfPerson: '負責人職位',
    contactEmail: '聯系郵箱',
    organizationIntroduction: '機構簡介',
    organizationsName: '機構名稱',
    organizationsName2: '機構名稱：',
    organizationsLandlineNumber: '單位座機',
    administrativeLevel: '行政級別',
    groupAddress: '機構地址',
    superiorOrganization: '上級單位',
    organizationCode: '組織機構代碼',
    pleaseEnterOrganizationCode: '請輸入組織機構代碼',
    telephone: '電話：'
  },
  servicelist: {
    serviceStaffList: '服務人員列表',
    enterPersonnelName: '請輸入人員姓名',
    search: '搜索',
    serviceArea: '服務區域',
    areasOfExpertise: '擅長領域',
    expand: '展開',
    hide: '收起',
    details: '詳情',
    details2: '詳情：',
    starLevel: '星 級',
    numberOfAssessments: '評價數',
    practiceExperience: '{number}年執業經驗',
    type: '類型',
    type2: '類型：',
    organization: '機構',
    organization2: '機構：',
    personnelDetails: '人員詳情',
    yearsOfPractice: '執業年限',
    yearsOfPractice2: '執業年限：',
    typeOfFunction: '職能類型',
    serviceOrganization: '服務機構',
    pendingCompletion: '待完成',
    completed: '已完成',
    basicInformation: '基本資料',
    gender: '性別',
    degreeOfEducation: '文化程度',
    dateOfBirth: '出生日期：',
    politicalStatus: '政治面貌',
    contactPhone: '聯系手機',
    IDNumber: '身份證號',
    contactEmail: '聯系郵箱',
    typeOfOccupation: '職業類型',
    qualificationCertificate: '資格證書',
    workingOrganization: '工作機構',
    workAddress: '工作地址',
    careerExperience: '從業經曆',
    nationality: '國籍'
  },
  adjust: {
    applicationMediation: '調解申請書',
    return: '返回',
    basicInformation: '基本信息',
    courtAcceptedApplication: '申請受理法院',
    caseType: '案件類型',
    partysBasicInformation: '當事人基本信息',
    zipCode: '郵政編碼',
    zipCode2: '郵政編碼：',
    deliveryMethod: '送達方式',
    deliveryMethod2: '送達方式：',
    fillInstrumentDeliveryAddress: '請務必填寫文書送達地址',
    instrumentDeliveryAddress: '文書送達地址',
    claimMatters: '請求事項',
    requestContent: '請求內容',
    requestContent2: '請求內容：',
    fillAppeals: '請填寫訴求內容',
    evidenceMaterial: '證據材料',
    materialCategories: '材料分類',
    materialCategories2: '材料分類：',
    pleaseSelect: '請選擇',
    materialName: '材料名稱',
    materialAttachments: '材料附件',
    materialAttachments2: '材料附件：',
    clickToUploadFile: '點擊上傳文件',
    newMaterial: '新增材料',
    newMaterials: '多種材料，請點擊“新增材料”',
    queryPassword: '查詢密碼',
    enterTheQueryPassword: '請輸入查詢密碼',
    submitAnApplication: '提交申請',
    judicialConfirmationSubmissionSucceed: '司法確認提交成功',
    applicationJudicialConfirmation: '司法確認申請書',
    certificateOfJudicialConfirmation: '司法確認書',
    mediationAgreement: '調解協議書',
    partysCertification: '當事人身份證明',
    civil: '民事',
    organ: '機關',
    publicInstitution: '事業單位',
    peoplesOrganization: '人民團體',
    stateOwnedEnterprise: '國有企業',
    affiliatedEnterprise: '國有聯營企業',
    collectivelyOwnedEnterprise: '集體企業',
    collectiveAffiliatedEnterprise: '集體聯營企業',
    privateEnterprise: '私營企業',
    privatePartnershipEnterprise: '私營合夥企業',
    privateLiabilityLimitedCompany: '私營責任有限公司',
    individualBusiness: '個體工商戶',
    individualPartnership: '個人合夥',
    SCollectiveAffiliatedEnterprise: '國有與集體聯營企業',
    SOPrivateAffiliatedEnterprise: '國有與私人聯營企業',
    CPrivateAffiliatedEnterprise: '集體與私人聯營企業',
    collectiveAndPrivateEnterprise: '國有、集體與私人聯營企業',
    limitedLiabilityCompany: '股份有限公司',
    limitedLiabilityCompany2: '有限責任公司',
    ChineseForeignJointVenture: '中外合資經營企業',
    ChineseForeignCoOperativeEnterprise: '中外合作經營企業',
    foreignFundedEnterprise: '外資企業',
    jointVentureEnterprise: '與大陸合資經營企業',
    jointOperationEnterprise: '與大陸合作經營企業',
    whollyOwnedEnterprises: '港、澳、台獨資企業',
    army: '軍隊',
    otherEconomic: '其他經濟'
  },
  applyRecord: {
    applicationFiling: '立案申請',
    operateAgain: '表單信息輸入不正確，請重新操作!',
    evidenceCompletedOrBlank: '每條證據材料必須填寫完整或者都爲空',
    applicationForFilingSucceed: '申請立案成功'
  },
  judicialDetail: {
    filingProgressInquiry: '立案進度查詢',
    caseInfo: '案件信息',
    serialNumber: '流水號',
    caseNo: '案號',
    courtOfAcceptance: '受理法院',
    caseType: '案件類型',
    causeAction: '案由',
    deliveryMethod: '送達方式',
    enforcementBasis: '執行依據',
    filingTime: '立案時間',
    sourceCase: '案件來源',
    litigationAmount: '訴訟標的額',
    identityOfTheFiling: '立案身份',
    litigationClaims: '訴訟請求',
    partysInformation: '當事人信息',
    partyType: '當事人類型',
    litigationStatus: '訴訟地位',
    agentLitem: '訴訟代理人',
    agentsSerialNumber: '訴訟代理人序號',
    nationality: '民族',
    typeOfDocument: '證件類型',
    typeOfDocument2: '證件類型：',
    pleaseSelectDocument: '請選擇證件類型',
    zipCode: '郵政編碼',
    nationality2: '國籍',
    politicalStatus: '政治面貌',
    degreeOfEducation: '文化程度',
    legalRepresentative: '法定代表人',
    legalRepresentativesTypeOfDocuments: '法定代表人證件種類',
    legalRepresentativesIDNumber: '法定代表人證件號碼',
    agentsInformation: '代理人信息',
    typeDefense: '辯護類型',
    agentsName: '代理人姓名',
    agentsPhoneNumber: '代理人電話',
    agentZIPCode: '代理人郵政編碼',
    agentsAddress: '代理人地址',
    agentsPractisingCertificateNumber: '代理人執業證號',
    typesOfAgentDocuments: '代理人證件種類',
    agentIDNumber: '代理人證件號碼',
    agentsOrganization: '代理人所在單位',
    serialNumber2: '代理人對應當事人序號',
    reviewInformation: '審查信息',
    caseStatus: '案件狀態',
    reviewer: '審查人',
    dateOfReview: '審查日期',
    reviewOpinions: '審查意見',
    reasonsForReviewOpinions: '審查意見理由',
    age: '年齡',
    partyNumber: '當事人序號'
  },
  //   lawsuit
  applylawsuit: {
    applicationForLitigation: '申請訴訟',
    enterKeywords: '可輸入關鍵詞進行搜索',
    amountOfSubject: '標的額',
    enterAmountOfSubject: '請輸入標的額',
    requestContent: '請求內容',
    fillAppeals: '請填寫訴求內容',
    appealMaterials: '訴求資料',
    materialCategories: '材料分類',
    materialName: '材料名稱',
    materialAttachments: '材料附件',
    clickToUploadFile: '點擊上傳文件',
    newMaterial: '新增材料',
    newMaterials: '多種材料，請點擊“新增材料”',
    submitAnApplication: '提交申請',
    selectCourt: '選擇法院',
    successfulSubmission: '訴訟申請提交成功',
    reselect: '當前法院和案件類型下沒有案由，請重新選擇',
    proceedingDetails: '訴訟詳情'
  },
  disputeType: {
    all: '全部',
    NPL: '網絡産品責任糾紛',
    NC: '網絡著作權、鄰接權權屬糾紛',
    OS: '網絡購物合同糾紛',
    NDN: '網絡域名權屬、侵權及合同糾紛',
    NI: '網絡侵害他人人身權、財産權等民事權益糾紛',
    NPI: '網絡公益訴訟',
    NSC: '網絡服務合同糾紛',
    AD: '網絡行政管理引發的行政糾紛',
    NFL: '網絡著作權、鄰接權侵權糾紛',
    NR: '網絡金融借款合同糾紛、小額借款合同糾紛',
    other: '其他糾紛',
    DOPR: '人格權糾紛',
    DOMFAS: '婚姻家庭、繼承糾紛',
    DPR: '物權糾紛',
    DCIPANG: '合同、無因管理、不當得利糾紛',
    DIPAC: '知識產權與競爭糾紛',
    DLAP: '勞動爭議、人事爭議',
    DMAM: '海事海商糾紛',
    CDOCSIA: '與公司、證券、保險、票據等有關的民事糾紛',
    DOTL: '侵權責任糾紛',
    CAFCSTSP: '使用特殊程序案件案由'
  },
  room: {
    invite: '邀請',
    happy: '高興：',
    angry: '憤怒：',
    sad: '悲傷：',
    calm: '平靜：',
    afraid: '恐懼：',
    annoyed: '厭惡：',
    surprised: '驚奇：',
    disputeMaterials: '糾紛材料',
    voice: '語音',
    video: '視頻',
    privateChat: '私聊',
    EmotionsOfCalm:
      '系統將通過面部表情識別出平靜、高興、<br>憤怒、恐懼、悲傷、厭惡、驚奇7種情緒，<br>調解過程中若當事人情緒過于憤怒或悲傷時<br>會發出預警，以協助您更好的調解糾紛。',
    detectVideoAndAudio: '檢測音視頻',
    playDiscipline: '播放紀律',
    endVideo: '結束視頻',
    stopRecording: '停止錄制',
    startRecording: '開始錄制',
    startRecording2: '開始錄制2',
    startRecording3: '當前視頻正在錄製中',
    startRecording4: '正在錄製',
    stopRecording2: '當前視頻已停止錄製',
    leave: '離開視頻',
    quitVideoConference: '退出了視頻會議',
    shareFaceExpressionRecognition: '人臉表情識別占比（%）',
    communicationRecords: '溝通記錄',
    videoTurnedOff: '視頻被關閉',
    observer: '觀摩人',
    browserNotSupportVideo:
      '當前浏覽器不支持視頻會議，請使用Chrome(版本要求高于52)或者QQ浏覽器(10.2)',
    connectionIsInterrupted: '會議連接中斷',
    videoConnectionFailed: '視頻連接失敗，請重試',
    retry: '重試',
    whetherToEnd: '是否結束當前視頻會議？',
    whetherToRcording: '是否開始錄制視頻？',
    whetherToStopRecording: '是否結束錄制視頻？',
    cantBeSccessedAgain: '結束視頻後，本次視頻調解將結束，不能再次進入視頻',
    leaveTemporarily: '暫時離開',
    endRecording: '結束錄制',
    enterWithinOneHour:
      '請于1小時內進入視頻，否則系統將默認結束本次視頻調解。。。',
    leaveVideo: '離開視頻，視頻頁面將會關閉',
    comfirmAndLeave: '視頻會議已結束，請確定離開',
    videoClosedByMediatorTip_1: '調解員臨時屏蔽您的音視頻',
    videoClosedByMediatorTip_2: '請靜待恢復',
    videoForbidden: '已屏蔽',
    videoRecovery: '解除屏蔽',
    voiceTotext: '調解員開啟了語音轉文字功能,語音將自動轉換為文字生成調解筆錄',
    voiceTotextOff: '調解員關閉了語音轉文字功能'
  },
  insideCaseInfo: {
    name: '姓名：'
  },
  inside: {
    communicationRecords: '溝通記錄',
    InSpeechRecognition: '語音識別中',
    turnOnSpeechRecognition: '開啓語音識別',
    manual: '手動輸入',
    speechRecognition: '語音識別',
    pressENTERToSend: '在此輸入消息，按回車鍵發送',
    mediationGuideline: '調解指引',
    mediationGuidelineCase: '{type}類型案件調解指引',
    videoCertification: '視頻認證',
    authenticateTheParties: '是否同意對當事人進行身份認證？',
    materialUpload: '材料上傳',
    tip: '提示：當前糾紛爲“{type}”，建議的證據有{evidence}上傳文件不超過20M'
  },
  privatechat: {
    noChatInformation: '當前沒有聊天信息',
    inConversation: '正在與{somebody}交談中',
    privateChatWindow: '私聊窗口'
  },
  other: {
    year: '年',
    language: '語言',
    day: '天',
    protocol: '《海南涉外民商事法庭案件多元化解平臺服務協議》'
  },
  leftMenu: {
    securitySettings: '安全設置',
    myProfile: '我的資料'
  },
  footer: {
    userCenter: '用戶中心',
    howToMediate: '如何進行調解',
    howToViewResults: '如何查看結果',
    mediationCentre: '調解中心',
    platformService: '平台服務',
    litigationService: '訴訟服務',
    contactMethod: '聯系方式',
    customerServiceTel: '客服電話：',
    customerServiceEmail: '客服郵箱：',
    smallProgram: '小程序'
  },
  realName: {
    realNameCertification: '實名認證',
    name: '姓 名：',
    IdNumber: '身份證：'
  },
  question: {
    platformGuide: '平台指南',
    userLogin: '用戶登錄',
    platformService: '平台服務',
    mediationServiceForDisputes: '糾紛調解服務',
    serviceResources: '服務資源',
    usageProcess: '使用流程',
    applicationForMediation: '申請調解',
    viewResults: '查看結果',
    accountSettings: '賬戶設置',
    realNameAuthentication: '實名認證',
    modifyPassword: '修改密碼',
    personalInformation: '個人信息',
    handwrittenSignature: '手寫簽名',
    register1: '新用戶可點擊平台首頁右上角的“注冊”按鈕，進入注冊頁面。',
    register2:
      '新用戶輸入手機號碼→點擊“獲取驗證碼”→輸入驗證碼→進行密碼設置，填寫完成後，用戶點擊《海南涉外民商事法庭案件多元化解平臺服務協議》進行查看，查看後勾選我同意《海南涉外民商事法庭案件多元化解平臺服務協議》選項，代表已閱讀並同意服務條款。',
    register3:
      '點擊“注冊”按鈕，彈窗提示用戶注冊成功，用戶可自行選擇是否前往個人中心完善個人信息。',
    login1:
      '用戶可點擊平台首頁右上角的“登錄”按鈕，進入登錄頁面，輸入手機號和密碼，點擊“登錄”按鈕即可成功登錄平台。登錄後可享受在線咨詢、在線調解、在線訴訟等服務。',
    forgetPwd: '忘記密碼',
    login2:
      '用戶可點擊平台首頁右上角的“登錄”按鈕，進入登錄頁面，如果忘記賬號的密碼，可點擊“忘記密碼 ?”按鈕，輸入“手機號”、“手機驗證碼”、“新密碼”、“重複密碼”這幾項必填信息，點擊“確認”按鈕，系統提示密碼修改成功。用戶可使用賬號和新密碼登錄平台。',
    userRegistrationAgreement: '用戶注冊協議',
    agreement:
      '《海南涉外民商事法庭案件多元化解平臺服務協議》爲平台與“用戶”間達成的協議，用戶在注冊時需閱讀該協議，確認相關信息。《協議》內容包括平台知識産權聲明、隱私權的規定、注冊及使用細則、平台使用規則、相關費用規定、爭議解決方式、違約責任、協議的修改及終止和其他約定等內容，平台已將上述免除或者限制責任的條款以粗體下劃線標識，提示“用戶”重點閱讀。',
    introductionToDisputeMediationService: '糾紛調解服務簡介',
    mediation:
      '調解是指由雙方當事人以外的第三者，以國家法律、法規和政策以及社會公德爲依據，對糾紛雙方進行疏導、勸說，促使他們相互諒解，進行協商，自願達成協議，解決糾紛的活動。',
    applicant:
      '申請人可在平台申請調解案件並可選擇自己的意向調解機構，調解機構管理員分配該案件給合適的調解員，調解員將聯系當事人處理該糾紛。',
    types: '糾紛調解服務有哪些類型',
    platform: '平台將糾紛調解分爲人民調解、行政調解。',
    mediator: '什麽是“調解員”',
    serviceStaff:
      '調解員是指在平台上線的調解組織中擔負調解民間糾紛工作的服務人員，工作內容主要是通過說服、疏導等方式，促使當事人在平等協商基礎上自願達成調解協議，化解矛盾、消除紛爭。',
    administrator: '管理員在平台主要負責什麽',
    platformMediationOrganization:
      '平台調解機構的管理員在調解過程中主要負責決定是否受理用戶的調解案件、分配相應的調解員以及對最終卷宗的審核。',
    responsible: '調解員在平台主要負責什麽',
    mainlyResponsible:
      '平台調解機構的調解員主要負責聯系調解案件的當事人了解矛盾糾紛的情況，並組織線上視頻會議或線下會議對矛盾糾紛進行化解，最終根據調解結果撰寫相應的文書，在平台設置調解狀態後負責對卷宗進行歸檔。',
    difference: '律師調解員和普通調解員的區別',
    lawyerMediator:
      '律師調解員同時也是律師，相對于普通調解員，律師調解員具有專業的法律知識和娴熟的職業技能、快速理清各方的矛盾爭議焦點、非官方的身份更容易讓當事人産生信任，親和力更強，調解效率更高。',
    serviceResources2: '平台有哪些服務資源',
    resourcesOfIndustries:
      '平台彙集了各條線各行業的解紛資源，主要分爲人民調解、行政調解，構建了一套有機銜接的“社會化的調解體系”；平台召集了各機構的資深人員構建更強大、更專業的專家咨詢庫，爲公衆提供更高品質的咨詢服務',
    howToMediate: '如何進行調解',
    userApplies:
      '糾紛登記員將根據案情將解紛登記至海南涉外民商事在線多元化解平台委託調解機構進行調解。案件進入調解後，調解員會發送短信至雙方當事人。請留意手機短信通知，並及時登錄海南涉外民商事在線多元化解平台參與調解。',
    viewMediationResults: '如何查看調解結果',
    logingOnThePlatform:
      '用戶登錄平台後，可在調解列表中查看所有與自己相關的調解案件，列表展示案件的調解進度，點擊“糾紛詳情”按鈕可查看案件詳情和相關文書材料。用戶也可根據調解進度對案件進行篩選。（服務-調解）',
    completeRealNameAuthentication: '如何完成實名認證',
    afterUserLogs:
      '用戶登錄平台後，可在賬戶中心-安全設置-身份認證中，填寫姓名、身份證號進行實名認證。對於無二代身份證的用戶，可在調解中與調解員視頻認證進行核驗。',
    whyNeedRealNameAuthentication: '爲什麽要實名認證',
    improveAccountSecurity:
      '實名認證可提升賬號安全級別和信任級別，在申請調解時，系統也將自動導入實名認證的信息，避免重複輸入。',
    modifyThePassword: '如何修改密碼',
    clickModify:
      '用戶登錄後在安全設置-登錄密碼點擊“修改”按鈕，輸入原密碼、新密碼、點擊“確認”按鈕即可成功修改密碼。',
    completePersonalInformation: '如何完善個人信息',
    personalDataSection:
      '用戶登錄平台後，可在賬戶中心下設的安全設置和個人資料板塊中對個人信息進行完善.',
    useOfEmail: '郵箱有什麽用途',
    identifyPersonalInformation:
      '郵箱作爲辨別個人信息的途徑之一，綁定郵箱可提高用戶使用平台的安全性，爲各項信息的通知提供便利。',
    twoAddresses: '兩個地址有什麽關系 ?（戶籍地址、現居地址）',
    permanentResidenceAddress:
      '戶籍地址爲用戶戶口登記所在的地址，現居地址爲用戶實際常住的地址，兩個地址可一致也可不一致，現居地址會被系統直接提取作爲咨詢、評估、調解時的相應糾紛發生地。',
    availableOnThePlatform: '平台有哪些簽名方式',
    instrumentMaterials:
      '對于需要當事人簽署的文書材料（例如調解筆錄、調解協議、司法確認申請書等），平台提供了手寫簽名的方式進行簽署。',
    handwrittenSignature2: '手寫簽名如何進行',
    elevantMaterialInstruments:
      '在調解員發送相關文書材料後，用戶在“工作台”（糾紛詳情或視頻會議界面）點擊相應文書，若無異議，可點擊“同意”按鈕，點擊後系統自動彈出二維碼，用戶可用微信掃描二維碼進行手寫簽名，點擊“確定”代表文書材料簽署成功。',
    userRegistration: '用戶注冊'
  },
  home: {
    personalCenter: '進入個人中心',
    exit: '退出',
    login: '登錄',
    enterPhoneOrEmail: '請輸入手機號或郵箱',
    register: '立即注冊',
    contactAdministrator: '其他問題聯系管理員',
    passwordLogin: '帳號密碼登錄',
    captchaLogin: '驗證碼登錄',
    passwordAndCaptchaLogin: '帳號密碼驗證碼登入',
    ukeyLogin: 'UKEY登錄',
    phoneNumberCantBeBlank: '手機號不可爲空',
    emailFormatError: '郵箱格式錯誤',
    staff: '工作人員',
    onlineDisputeResolution: '在線多元化解',
    onlineDisputeResolution2:
      '矛盾糾紛在線錄入，權威資源在線響應，多元資源專業支持，矛盾糾紛快速化解',
    qualityTeam: '優質團隊 化解糾紛',
    qualityTeam2: '按類型高效匹配機構調解員',
    saveTime: '省時省力 維護權益',
    saveTime2: '足不出戶，一鍵解紛',
    wholeProgress: '全場跟蹤 案件進展',
    SMSNotification: '案件流轉全流程短信通知',
    organizer: '主辦單位：',
    ChineseDomain: '中文域名：',
    filingNumber: '備案號：',
    courtAddress: '法院地址：',
    courtTel: '法院電話：',
    technicalServiceHotline: '技術服務熱線：',
    welcome: '歡迎您',
    welcomeTo: '歡迎您來到海南涉外民商事法庭案件多元化解平臺',
    professional: '專業咨詢師、機構調解員，多元化解紛資源',
    guidingCase: '引調案件',
    hello: '您好，',
    please: '請',
    mediation: '糾紛調解:',
    case: '例',
    title1: '港澳台案例',
    content1:
      '港澳台案例是指案件的當事人是中國香港特別行政區、澳門特別行政區、台灣地區的公民或者組織，或者訴訟標的、涉訴的法律關系發生在港澳台地區，包括民商事案例、刑事案例及行政案例等。',
    title2: '最高院指導性案例',
    content2:
      '最高院指導性案例是指依據《最高人民法院關于案例指導工作的規定》程序編選的，由最高人民法院審委會討論並統一發布，代表最高人民法院意志的，各級人民法院在審判類似案件時應當參照的指導性案例。該類案例往往受社會廣泛關注、涉及法律原則、具有典型意義、涉及疑難複雜或者新類型問題或有其他指導作用。',
    title3: '一帶一路涉外案例',
    content3:
      '一帶一路涉外案例是指案件含有涉外因素，包括主體、標的或法律關系的內容涉外的民商事案件，行爲發生地、結果發生地、實施主體或訴訟過程涉外的刑事案件，外國原告或第三人針對中國行政機關提起訴訟的行政案件。涉及“一帶一路”建設的指導性案例是指由最高人民法院在梳理、總結近年來涉外海事海商審判工作經驗的基礎上，集中發布的指導性案例，旨在統一涉外商事、海事案件審判法律適用，實現類案同判。',
    learnMore: '了解詳情',
    HainanFreeTradeZone: '海南自貿區'
  },
  service: {
    workingExperience: '從業經驗',
    noEvaluation: '暫無評價',
    searchOrganization: '搜索 機構',
    searchStaff: '搜索 人員',
    searchLawyer: '搜索 公益律師'
  },
  help: {
    stepsMediation: '申請調解步驟',
    courtLedMediation: '法院引調',
    allocationMediation: '調解案件分配調解機構',
    platformNotifies: '平台通知雙方當事人',
    SMSNotifies: '短信通知及時線上調解',
    mediatesOnline: '調解員在線調解',
    mediatorIntervene: '調解員介入，進行調解',
    successfulMediation: '調解成功',
    mediatorConfirms: '調解員確認調解狀態',
    judicialConfirmationOrMediation: '申請司法確認或調解書',
    judicialConfirmation: '申請司法確認',
    regAcc: '糾紛登記員登記糾紛信息',
    appMed: '短信或郵件通知及時線上調解',
    medOnl: '調解員介入，三方在線視頻調解',
    medSuc: '調解成功，在線確認調解協議',
    appJud: '在線申請法院確認調解協議效力'
  },
  agreementRegister: {
    serviceAgreement: '海南涉外民商事法庭案件多元化解平臺服務協議',
    versionEffectiveDate: '版本生效日期：',
    time: '2018年04月14日 10:49',
    indent:
      '“廣州法院在線涉港澳糾紛多元化解平台”（以下簡稱“多元平台”）是在線糾紛解決方式的一體化服務平台，旨在通過在線方式爲人民群衆提供咨詢、調解、仲裁、評估、訴訟等服務。在使用多元平台的各項服務前，請您務必仔細閱讀並透徹理解本協議，特別是免除或限制責任的條款、法律適用和爭議解決條款。免除或者限制責任的條款將以粗體下劃線標識，您應重點閱讀。您可以選擇不使用多元平台服務，但如果您使用多元平台服務即視爲您認可了本服務協議的所有內容。',
    indent2:
      '當您按照注冊頁面提示填寫信息、閱讀並同意本協議且完成全部注冊程序後，即表示您已充分閱讀、理解並接受本協議的全部內容，並與多元平台達成一致，成爲多元平台“用戶”。閱讀本協議的過程中，如果您不同意本協議或其中任何條款約定，您應立即停止注冊程序。',
    title: '一、知識産權聲明',
    content:
      '多元平台擁有多元平台網站內所有信息內容、使用技術、設計樣式、設計程序的知識産權，任何爲商業目的複制和傳播本網站內信息的行爲都可能構成對本網站知識産權的侵犯，本網站將依法維護自身的權利。未經多元平台許可，任何人不得擅自使用。否則，多元平台將依法追究法律責任。',
    title2: '二、關于隱私權的規定',
    num1:
      '1. 多元平台尊重並保護所有使用多元平台用戶的個人隱私權。包括您在多元平台提供的戶名、IP地址、銀行賬戶、郵箱、聯系方式、浏覽器的類型、訪問時間、軟硬件特征信息及您需求的網頁記錄等數據。多元平台不會向第三方(與多元平台存在合作關系的公司除外)提供、分享您的個人信息。',
    num2:
      '2. 您在使用多元平台進行交易的有關數據、您的信用評價、多元平台因您違法或違約而對您采取的處理決定，均爲本網站的公開信息，不是隱私權的保護範圍。',
    num3:
      '3. 多元平台不允許任何第三方以任何手段收集、編輯、出售或者無償傳播您的個人信息，任何多元平台用戶如從事上述活動，請受害者及時書面告知多元平台並提供相關證據，經本網站審查屬實後，或者本網站自行發現這種侵權情況時，網站將有權立即終止與侵權用戶的服務協議。',
    num4:
      '4. 如不屬于多元平台用戶的第三者利用您在本網站的信息侵害您的權益，因本網站無權對非本網站用戶采取措施，請您及時依法維護自己的權利，本網站將給予必要的配合。',
    num5:
      '5. 爲了更好地爲您服務或者保護其他多元平台用戶的合法權益，多元平台有權通過使用您提供的個人信息，向您發送相關信息，采取保護您的隱私的措施，進行相關的調查。',
    num6:
      '6. 如果您就您的隱私和信息向多元平台投訴其他侵權人，多元平台有權將您與投訴相關的信息及權利證明向被投訴人披露，以便維護您的權益和解決糾紛。',
    num7:
      '7. 如果您被投訴或者違反國家法律、法規、多元平台的服務協議和相關規則，多元平台有權向相關方披露您的信息，但該披露以保護合法權益者的利益爲限。',
    num8:
      '8. 在多元平台的咨詢者需要與咨詢師交流或交易時，作爲交易雙方的咨詢者和咨詢師均爲交流或交易需要而有權知道對方相關的信息，知道對方交易信息的一方均負有義務不向第三方泄露對方的信息。如果您侵權泄露他人的信息，在受害方能證實侵權的情況下，多元平台有權向受損害方和國家相關部門披露您的信息。',
    num9:
      '9. 爲了實現您登陸本網站的目的，或者多元平台出于與您交流或者交易的需要，多元平台有權在合理限度內使用您的信息。',
    num10:
      '10. 請您妥善保護好您的賬戶、密碼，多元平台也將采取技術措施，防止您的信息被泄露，但您認可因當前技術和現實的限制，沒有百分百絕對安全的技術措施，在多元平台沒有故意行爲時，不對此承擔法律責任。'
  },
  menuDetail: {
    caseDetails: '案件詳情',
    accept: '受理',
    notAccept: '不受理',
    allotMediators: '分配調解員',
    reallotMediators: '重新分配調解員',
    bookMediation: '預約調解',
    sendInstruments: '發送文書',
    NoobjectionMediation: '無異議調解方案',
    NoncontroversialFactsConfirmation: '無爭議事實確認協議',
    mediationStatus: '調解狀態',
    mediationFailed: '調解失敗',
    applicationJudicialConfirmation: '司法確認申請書',
    applicationMediation: '調解申請書',
    generateElectronicFiles: '生成電子卷宗',
    signInstruments: '文書簽署',
    noAgreementYet: '暫無協議',
    chooseMediator: '選擇調解員',
    enterMediatorsName: '請輸入調解姓名',
    choose: '選擇',
    importantTips: '重要提示',
    acceptTheCase:
      '請您根據真實發生的糾紛情況決定是否受理該案件，若您選擇“不受理”，將導致申請人無法享受本機構提供的調解服務。',
    notAcceptTheCase:
      '請您根據真實發生的糾紛情況決定是否受理該案件，若您選擇“受理”，本機構調解員將爲案件提供調解服務。',
    endingMediationReports: '終結調解報告',
    serialNumber: '流水號',
    plaintiff: '原告',
    contactNumber: '聯系電話',
    contactType: '聯系方式',
    agentLitem: '訴訟代理人',
    agentsPhoneNumber: '代理人電話',
    Defendant: '被告',
    reasonsToEndMediation: '終結調解原因',
    selectTheReasonsMediation: '請選擇調解原因',
    enterOtherReasons: '請填寫其他原因',
    plaintiffsOpinions: '原告意見：',
    enterPlaintiffsOpinions: '請填寫原告意見',
    defendantsOpinions: '被告意見：',
    enterDefendantsOpinions: '請填寫被告意見',
    majorDifferences: '雙方主要分歧：',
    nonContentiousFacts: '雙方確認的無爭議事實：',
    majorDifferences2: '雙方主要分歧',
    nonContentiousFacts2: '雙方確認的無爭議事實',
    haveSubmitted: '已提交',
    notSubmitted: '未提交',
    submit: '提交',
    haveSaved: '已保存',
    preview: '預覽',
    invalid: '作廢',
    confirmationMediationFailure: '調解失敗確認',
    changeCaseStatus:
      '是否確認將案件狀態改爲“調解失敗，確認後，您將結束對該案件的調解，並撰寫調解終結報告',
    notAcceptCase: '不受理案件',
    detailedReasons: '詳細原因',
    screeningMediationOrganization: '調解機構篩選',
    enterReasonsTransfer: '請先填寫轉出原因(必填)',
    selectType: '請選擇類型',
    enterOrganization: '請輸入機構名稱',
    transfer: '轉出',
    disputeInformation: '糾紛信息',
    caseMaterials: '案件材料',
    clericalMaterials: '文書材料',
    mediationRecords: '調解記錄',
    notUnderOrganization: '非本機構管轄',
    otherOrganizationsAccepted: '其他機構已受理/解決',
    mediationIsntGranted: '依案件性質不予調解',
    mediationTypes: '所有調解類型',
    peopleMediation: '人民調解',
    administrativeMediation: '行政調解',
    saveSuccessfully: '保存成功',
    mediator1: '測試調解員1',
    submitSuccessfully: '提交成功',
    mediationHasFailed: '調解已失敗',
    mediationTranscript: '調解筆錄',
    investigationTranscript: '調查筆錄',
    asssignMediatorSuccessfully: '分配調解員成功',
    transferMediationOrganizationSuccessfully: '轉移調解機構成功',
    rejectSuccessfully: '不受理成功',
    acceptSuccessfully: '受理成功',
    other: '其他',
    plaintiffRequestsClosure: '原告要求終結',
    defendantRequestsClosure: '被告要求終結',
    cantDeliverToDefendant: '被告無法送達',
    contactParties:
      '調解成功！請線下和雙方當事人確認，請告知雙方當事人在30s內進行選擇，如若不選擇則默認選擇撤訴處理。否則出具調解申請書',
    requestMediationAgreement: '請求出具調解書',
    withdrawCase: '撤 訴',
    pleaseWait: '請等待',
    judicail: '司法確認',
    litigation: '訴訟立案',
    arbitration: '在線仲裁',
    exitUser: {
      thisUser: '該用戶',
      hasHistory: '存在歷史數據',
      isOverwrite: '是否覆蓋當前信息？',
      yes: '是',
      no: '否'
    }
  },
  MediationRoom: {
    mediationRoom: '調解室',
    contactsList: '聯系人列表',
    noMoreMessages: '暫無更多消息',
    send: '發送',
    companyName: '企業名稱',
    companyCode: '企業信用代碼',
    groupChat: '群聊',
    enterContentBeforeSending: '請輸入內容後發送',
    refreshAndTry: '消息發送失敗，請刷新後重試',
    chatDisconnected: '聊天已斷開，請刷新後重試',
    group: '群'
  },
  registersuccess: {
    registrationIsCompleted: '注冊已完成！',
    completeRealNameCertification: '完成實名認證',
    registerAccount: '糾紛登記',
    toRegister: '填寫手機號密碼進行注冊',
    fillTheCaseInformation: '填寫案件信息，上傳證據材料',
    onlineMediation: '在線調解',
    organizeOnlineVideoMediation: '調解員了解糾紛詳情，組織在線視頻調解',
    partiesReachMediationAgreement: '雙方當事人達成調解協議',
    ApplyJudicialConfirmation: '申請司法確認',
    judicialConfirmation: '雙方當事人共同申請司法確認',
    enterIDNumber: '請輸入二代身份證號',
    realNameCertificationSucceed: '恭喜您，實名認證成功！',
    viewTheInformation: '您可以到個人中心查看實名後的資料。'
  },
  //   userCenter
  evlaLetter: {
    userReviews: '用戶評價',
    trainingMaterials: '培訓材料',
    starRating: '星級評價',
    numberOfAssessments: '評價數',
    numberOfAssessments2: '評價數：',
    caseNo: '案件編號',
    assessorsName: '評價人姓名',
    assessmentTime: '評價時間',
    starLevel: '星級',
    starLevel2: '星 級：',
    content: '內容'
  },
  level: {
    low: '低',
    middle: '中',
    high: '高'
  },
  header: {
    hello: '您好，',
    online: '在線',
    busy: '繁忙',
    exit: '退出',
    home: '首頁',
    LegalAdvice: '法律咨詢',
    more: '更多',
    lawsAndRegulations: '法律法規',
    caseLibrary: '案例庫',
    regulatoryCase: '法規案例',
    serviceResources: '服務資源',
    helpCenter: '幫助中心',
    mediationCentre: '調解中心',
    FAQ: '常見問題',
    welcomeToRegister: '歡迎注冊',
    alreadyHave: '已有帳號？',
    pleaseLogin: '請登錄',
    welcomeToLogin: '歡迎登錄',
    staffLogin: '工作人員登錄',
    retrievePassword: '找回密碼',
    backLogin: '返回登錄',
    backToHome: '返回首頁',
    help: '幫助',
    resourceDatabase: '涉外民商事調解資源庫'
  }
}



// WEBPACK FOOTER //
// ./src/publicResource/utils/lang/tw.js